export const DEFAULT_LOCALE = process.env.REACT_APP_DEFAULT_LANGUAGE ?? 'en';
export const DEFAULT_ADMIN_LOCALE = 'en';

export const circularDiagramColor = '#555DFF';

export const LOCAL_STORAGE_ASSESSMENT_DATA = 'assessmentData';

export const RESULT_BAR_LEVELS = [1, 2, 3, 4, 5, 6];
